import { combineReducers } from 'redux';
import * as types from './types';
import initialState from './intialState';
import editPasswordReducer from '../EditPassword/ducks';

type Action = { type: string; payload?: any };

const defaultAction: Action = { type: '' };

const personalDetailsReducer = (state = initialState.entities, action: Action = defaultAction) => {
  switch (action.type) {
    case types.FETCH_PERSONAL_DETAILS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const purchasesReducer = (state = initialState.purchases, action: Action = defaultAction) => {
  switch (action.type) {
    case types.FETCH_PURCHASES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const showPersonalDetailsReducer = (
  state = initialState.showPersonalDetails,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.FETCH_PERSONAL_DETAILS_BEGIN:
      return {
        ...initialState.showPersonalDetails,
        isLoading: true
      };
    case types.FETCH_PERSONAL_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.FETCH_PERSONAL_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case types.FETCH_PERSONAL_DETAILS_DISMISS_ERROR:
      return initialState.showPersonalDetails;
    default:
      return state;
  }
};

const updatePersonalInformationReducer = (
  state = initialState.updatePersonalInformation,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.UPDATE_PERSONAL_INFORMATION_BEGIN:
      return {
        ...initialState.updatePersonalInformation,
        isLoading: true
      };
    case types.UPDATE_PERSONAL_INFORMATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_PERSONAL_INFORMATION_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case types.FETCH_PERSONAL_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

const updateContactsDetailsReducer = (
  state = initialState.updateContactsDetails,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.UPDATE_CONTACTS_DETAILS_BEGIN:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_CONTACTS_DETAILS_SUCCESS:
      return {
        ...initialState.updateAddress
      };
    case types.UPDATE_CONTACTS_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    default:
      return state;
  }
};

const updateAddressReducer = (
  state = initialState.updateAddress,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.UPDATE_ADDRESS_BEGIN:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_ADDRESS_SUCCESS:
      return {
        ...initialState.updateAddress
      };
    case types.UPDATE_ADDRESS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case types.FETCH_PERSONAL_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

const userProfileDataReducer = (
  state = initialState.userProfileData,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.FETCH_USER_PROFILE_DATA_BEGIN:
      return {
        ...state,
        isLoading: true
      };
    case types.FETCH_USER_PROFILE_DATA_SUCCESS:
      return {
        ...action.payload,
        isLoading: false
      };
    case types.FETCH_USER_PROFILE_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    default:
      return state;
  }
};

const updateUserProfileDataReducer = (
  state = initialState.updateUserProfileData,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.UPDATE_USER_PROFILE_DATA_BEGIN:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_USER_PROFILE_DATA_SUCCESS:
      return initialState.updateUserProfileData;
    case types.UPDATE_USER_PROFILE_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case types.FETCH_USER_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  entities: personalDetailsReducer,
  purchases: purchasesReducer,
  showPersonalDetails: showPersonalDetailsReducer,
  updatePersonalInformation: updatePersonalInformationReducer,
  updatePassword: editPasswordReducer,
  updateContactsDetails: updateContactsDetailsReducer,
  updateAddress: updateAddressReducer,
  userProfileData: userProfileDataReducer,
  updateUserProfileData: updateUserProfileDataReducer
});

export default reducer;
